/*
 * @Descripttion:
 * @Author: Xinner
 * @Date: 2021-01-26 09:28:03
 * @LastEditors: Xinner
 * @LastEditTime: 2021-01-26 09:30:33
 */
import { RouterItem } from '@/utils/interfaces';

import systemManageRoutes from './system-manage-route';
import topRoutes from './top-route';

/** 所有动态路由 */
const routes = [...topRoutes, ...systemManageRoutes];

export default routes;
